import { render, staticRenderFns } from "./QuoteListings.vue?vue&type=template&id=056f2b6e"
import script from "./QuoteListings.vue?vue&type=script&lang=js"
export * from "./QuoteListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports